export default "__VITE_ASSET__D09uMSS0__"